import { render, staticRenderFns } from "./MSecondaryPlanUnsubscribe.vue?vue&type=template&id=c2bc68b0&"
import script from "./MSecondaryPlanUnsubscribe.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryPlanUnsubscribe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports